import { equals, has, path, prop, split, defaultTo } from 'ramda'
import moment from 'moment'

const dateOfBirthFormats = ['DD/MM/YYYY', 'DD/MM/YY']

export const getDateOfBirthMoment = value => {
  const dob = moment(value, dateOfBirthFormats, true)
  const dateParts = split('/', defaultTo('', value))

  if(dob.isValid() && defaultTo('', dateParts[2]).length === 2 && dob.isAfter(moment())){
    return dob.subtract(100, 'years')
  }

  return dob
}

export const isRequired = value => value ? undefined : 'Value Required'
export const isNumber = value => value && isNaN(Number(value)) ? 'Must be a Number' : undefined
export const isValidEmail = value => /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value) ? undefined : 'Invalid Email'
export const isPasswordMatched = (value, form) => {
  let password = ''
  if(has('signup', form)){
    password = path(['signup', 'password'], form)
  }else{
    if(has('password', form))
      password = prop('password', form)
    else
      password = prop('newPassword', form.changePassword)
  }
  return equals(value, password) ? undefined : `Password didn't match`
}
export const isMaxLengthValid = value => value.length < 8 ? 'Minimum 8 characters required' : undefined
export const isCapitalCharacterExist = value => /[A-Z]/.test(value) ? undefined : 'At least 1 capital character required'
export const isNumericCharacterExist = value => /[0-9]/.test(value) ? undefined : 'At least 1 numeric character required'
export const max35Hours = value => value > 35 ? `Max 35 hours` : undefined
export const max200Words = value => split(' ', defaultTo('',value)).length > 200 ? 'Max 200 words allowed' : undefined
export const isValidNMC = value => /^[0-9]{2}[a-zA-Z]{1}[0-9]{4}[a-zA-Z]{1}$/i.test(value) ? undefined : 'Invalid NMC Pin Format'
export const max60Miles = value => value > 60 ? `Max 60 miles allowed` : undefined
export const min6CharactersRequired = value => value.length < 6 ? 'Minimum 6 characters required' : ''
export const min9CharactersRequired = value => value.length < 9 ? 'Minimum 9 characters required' : ''
export const normalizeDateOfBirth = (value, previousValue = '') => {
  if (!value) return value

  const digits = value.replace(/\D/g, '').slice(0, 8)

  let result = digits
  if (digits.length >= 4) {
    result = `${digits.slice(0, 2)}/${digits.slice(2, 4)}/${digits.slice(4)}`
  } else if (digits.length >= 2) {
    result = `${digits.slice(0, 2)}/${digits.slice(2)}`
  }

  // Allow deleting an auto-inserted slash instead of it re-appearing
  if (value.length < previousValue.length && result.endsWith('/')) {
    result = result.slice(0, -1)
  }

  return result
}

export const isValidDateOfBirth = value => {
  if(!value) return undefined
  if(!/^\d{2}\/\d{2}\/(\d{2}|\d{4})$/.test(value)) return 'Use date format dd/mm/yyyy or dd/mm/yy'

  const dob = getDateOfBirthMoment(value)

  if(!dob.isValid()) return 'Invalid date'
  if(dob.isAfter(moment(), 'day')) return 'Date of birth cannot be in the future'

  return undefined
}
